import axios, { AxiosResponse } from "axios";
import ApplicationDetail from "../../../services/applicationDetail.service";
import { REACT_APP_API_BASE_URL } from "../../latest-utils/const";
import { ILogDto } from "../AuthLogin/latest-services/log.dto";

export class APIRequest {
    private static _instance: APIRequest = new APIRequest();
    private appDetail: ApplicationDetail = ApplicationDetail.instance;

    constructor() {
        if (APIRequest._instance) {
          throw new Error('Use DataService.instance');
        }
        APIRequest._instance = this;
    }

    static get instance(): APIRequest {
        return APIRequest._instance;
    }

    getExternal = async (url: string, config = {}) => {
        return axios.get(url, { headers: {
            'Content-Type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
            ...config
        }}).then(res => res).catch(error => error?.response?.data);
    }

    get = async (url: string, config = {}) => {
        const accessToken = this.appDetail.getAccessToken() || localStorage.getItem('accessToken') || null;
        url = this.addTimestampToUrl(REACT_APP_API_BASE_URL + url);
        let dbType = localStorage.getItem('dbType')
        return axios.get(url, { headers: {
                'Content-Type': 'application/json',
                'X-Content-Type-Options': 'nosniff',
                'dbType': "MA",
                accessToken,
                'X-REF-TOKEN': localStorage.getItem('X-REF-DATA') || undefined,
            }, ...config
        }).then(res => res).catch(error => error?.response?.data);
    }

    post<T, R>( url: string, body: T, config = {} ): Promise<any> {
        const accessToken = this.appDetail.getAccessToken() || localStorage.getItem('accessToken') || null;
        url = this.addTimestampToUrl(REACT_APP_API_BASE_URL + url);
        return axios.post(url, JSON.stringify(body), { headers: {
            'Content-Type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
            accessToken,
            'X-REF-TOKEN': localStorage.getItem('X-REF-DATA') || undefined,
            ...config
        }}).then(res => res).catch(error => error?.response?.data);
    }

    private addTimestampToUrl = (url: string): string => {
        if (url) {
          let new_url = new URL(url);
          let search_params = new_url.searchParams;
          search_params.set('dt', new Date().valueOf().toString());
          new_url.search = search_params.toString();
          return new_url.toString();
        }
    };

    log (body: ILogDto) {
        this.post('/master/log', { ...body, ip: sessionStorage.getItem('ip'), url: REACT_APP_API_BASE_URL + body.url });
    }

    getIp = async () => {
        const ip = await axios.get('https://api.ipify.org?format=json').catch(err => null);
        if (ip?.ip !== null) {
            sessionStorage.setItem('ip', ip.ip);
        }
    }
}